import * as types from '../store/mutation-types';

export default {
	methods: {
		/**
		 * 重置教育经历信息
		 */
		resetEdu() {
			this.$store.commit(types.CHANGE_EDUTION, {
				key: 'eduIndex',
				value: -1
			});
			this.$store.commit(types.CHANGE_EDUTION, {
				key: 'eduState',
				value: 0
			});
			this.$store.commit(types.CHECK_EDUINFO, {
				key: 'gradschool',
				value: '',
				state: null
			});
			this.$store.commit(types.CHECK_EDUINFO, {
				key: 'gradmajor',
				value: '',
				state: null
			});
			this.$store.commit(types.CHECK_EDUINFO, {
				key: 'gradtime',
				value: '',
				state: null
			});
		}
	}
};



// WEBPACK FOOTER //
// ./src/module/basic/mixins/eduMixin.js